import {getPullRequestTabSuffix} from '@github-ui/paths'
import {useLocation} from '@github-ui/react-router'
import {GlobalCommands} from '@github-ui/ui-commands'
import {useNavigate} from '@github-ui/use-navigate'
import type {StackData} from '../page-data/payloads/header'

type StackNavigationCommandsProps = {
  pullRequestNumber: number
  stack: StackData
}

export function StackNavigationCommands({pullRequestNumber, stack}: StackNavigationCommandsProps) {
  const {pathname} = useLocation()
  const navigate = useNavigate()
  const tabSuffix = getPullRequestTabSuffix(pathname)

  const currentPullRequestIndex = stack.pulls.findIndex(pull => pull.number === pullRequestNumber)
  const downstackPullRequest = currentPullRequestIndex >= 0 ? stack.pulls[currentPullRequestIndex + 1] : undefined
  const upstackPullRequest = currentPullRequestIndex > 0 ? stack.pulls[currentPullRequestIndex - 1] : undefined

  const navigateToPullRequest = (pullRequest: StackData['pulls'][number] | undefined) => {
    if (!pullRequest) return

    navigate(`${pullRequest.url}${tabSuffix}`)
  }

  return (
    <GlobalCommands
      commands={{
        'pull-requests:navigate-downstack': () => navigateToPullRequest(downstackPullRequest),
        'pull-requests:navigate-upstack': () => navigateToPullRequest(upstackPullRequest),
      }}
    />
  )
}
